export default function StickyHeader(window, document) {
  const header = document.querySelector('header');
  const topClass = 'header__container--top';
  const hiddenClass = 'header__container--hidden';

  // The amount of downward movement before header is hidden
  const downTolerance = 10;
  let hasScrolled = false;
  let lastScrollTop = 0;

  const _redraw = function () {
    const pageY = window.scrollY;

    // Hide header
    if (pageY > lastScrollTop + downTolerance) {
      header.classList.add(hiddenClass);
    }

    // Display header
    if (pageY < lastScrollTop || pageY <= 0) {
      header.classList.remove(hiddenClass);
    }

    lastScrollTop = pageY;
    hasScrolled = false;
  };

  const _onScroll = function () {
    if (window.scrollY <= 0) {
      header.classList.add(topClass);
    } else {
      header.classList.remove(topClass);
    }
    if (!hasScrolled) {
      window.requestAnimationFrame(_redraw);
    }
    hasScrolled = true;
    window.requestAnimationFrame(_onScroll);
  };

  _onScroll();
}
